import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const Book: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_12280_30171)'>
        <path
          d='M23.4633 7.14299C23.1664 7.14299 22.9262 7.36177 22.9252 7.63015V17.4541C19.7454 17.029 16.4985 17.3505 13.4945 18.3886C14.0609 17.8049 14.7464 17.3257 15.514 16.9785C18.309 15.7224 21.0735 16.7632 21.6 16.9838H21.599C21.766 17.0546 21.9603 17.0422 22.1146 16.9528C22.2689 16.8633 22.3627 16.7083 22.3627 16.5418V6.14547C22.3627 5.95503 22.2416 5.78318 22.0511 5.70259C21.4476 5.44838 18.2699 4.25437 15.0364 5.70791V5.7088C13.8059 6.27038 12.7591 7.1145 12.0002 8.15799C11.2414 7.11455 10.1945 6.27042 8.96394 5.7088C5.73045 4.25524 2.55272 5.44927 1.95022 5.70259C1.75979 5.7832 1.6387 5.95504 1.6387 6.14547V16.5427V16.5418C1.6387 16.7083 1.73245 16.8634 1.88674 16.9528C2.04104 17.0423 2.23537 17.0547 2.40237 16.9838C2.92776 16.7624 5.69335 15.7225 8.48834 16.9785H8.48736C9.25493 17.3257 9.94048 17.8049 10.5069 18.3886C7.50289 17.3505 4.25591 17.029 1.07517 17.4542V7.63018C1.07517 7.3609 0.833961 7.14301 0.537098 7.14301C0.240234 7.14301 0 7.36091 0 7.63018V18.0274C0 18.1718 0.0703122 18.3091 0.192382 18.4021C0.314451 18.4942 0.47558 18.5332 0.632805 18.5075C4.41604 17.8839 8.32027 18.3897 11.7598 19.9486C11.7627 19.9504 11.7666 19.9504 11.7695 19.9522C11.793 19.9619 11.8164 19.9699 11.8408 19.977C11.8476 19.9787 11.8555 19.9814 11.8623 19.9832C11.8691 19.9849 11.8701 19.9858 11.874 19.9867H11.875C11.916 19.9956 11.957 20 11.999 20C12.04 20 12.082 19.9956 12.1221 19.9867H12.125C12.1289 19.9867 12.1328 19.9841 12.1367 19.9832C12.1406 19.9823 12.1514 19.9787 12.1582 19.977C12.1826 19.9699 12.206 19.9619 12.2285 19.9522C12.2314 19.9504 12.2353 19.9504 12.2383 19.9486H12.2392C15.6787 18.3888 19.584 17.883 23.3672 18.5075C23.5244 18.5332 23.6855 18.4942 23.8076 18.4021C23.9297 18.3091 24 18.1718 24 18.0274V7.63018C24 7.50174 23.9434 7.37773 23.8428 7.28562C23.7422 7.19439 23.6055 7.14301 23.4629 7.14301L23.4633 7.14299ZM15.513 6.58141C17.9466 5.48749 20.3578 6.13497 21.2885 6.46714V15.8288C20.0239 15.4435 17.5473 14.9767 15.0385 16.106V16.1051C14.0766 16.5409 13.2251 17.153 12.5386 17.9032V9.23504C13.2055 8.09418 14.2446 7.16766 15.514 6.58131L15.513 6.58141ZM8.96332 16.1052C7.90862 15.6339 6.7475 15.3912 5.57083 15.3974C4.59916 15.4019 3.63334 15.5471 2.71235 15.8288V6.46626C3.64204 6.13411 6.05308 5.48749 8.48782 6.58052L8.48684 6.58141C9.75636 7.16689 10.7954 8.09342 11.4633 9.23423V17.9031C10.7768 17.1529 9.92526 16.5408 8.96432 16.105L8.96332 16.1052Z'
          fill='url(#paint0_linear_12280_30171)'
          stroke='url(#paint1_linear_12280_30171)'
          strokeWidth='0.3'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_12280_30171'
          x1='4.96985'
          y1='6.02283'
          x2='9.83275'
          y2='21.6174'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_12280_30171'
          x1='4.96985'
          y1='6.02283'
          x2='9.83275'
          y2='21.6174'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <clipPath id='clip0_12280_30171'>
          <rect
            width='24'
            height='24'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Book;
